/** Formatting for text input as a source to be formatted. If the source value is numeric, date, etc. it goes in
    a different module. */

/** @return String value as a string suitable for showing in an input text box. */
export const formatInputText = (value) => (value === null || value === undefined) ? '' : String(Math.round(value));
